import { useTranslation } from 'react-i18next';
import { Dialog } from '../design-system';

const UsageRestrictionModal = ({ onClose }) => {
  const { t } = useTranslation('modals');
  return (
    <Dialog
      isOpen
      onClose={onClose}
      ariaLabel={t('usage.plan.restrictionTitle')}
      showClose={false}
      className="usage-coming-soon-modal"
    >
      <h3>{t('usage.plan.restrictionTitle')}</h3>
      <p style={{ whiteSpace: 'pre-line' }}>
        {t('usage.plan.restrictionGracePeriodMessage')}
      </p>
      <div className="usage-confirm-buttons" style={{ justifyContent: 'center' }}>
        <button
          className="usage-confirm-btn confirm"
          style={{ flex: 'none', minWidth: '120px' }}
          onClick={onClose}
        >
          {t('usage.plan.restrictionOk')}
        </button>
      </div>
    </Dialog>
  );
};

export default UsageRestrictionModal;
